<!-- 商品总账流水列表 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <div class="page_content_top_line div_btn" style="padding: 5px 0;">
            <el-button type="primary" size="mini" @click="exportChange()">
               导出
            </el-button>
         </div>
         <div class="page_content_top_line">
            <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" :model="getRequestData" class="demo-form-inline">
               <el-form-item>
                  <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
                  <el-date-picker v-model="getRequestData.SRQ" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
               </el-form-item>
               <el-form-item>
                  <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
                  <el-date-picker v-model="getRequestData.ERQ" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
               </el-form-item>
               <el-form-item>
                  <label slot="label" :style="$common.labelStyle('商品名称')" v-html="$common.htmlLabel('商品名称')"></label>
                  <el-input placeholder="" v-model="getRequestData.PNAME" clearable></el-input>
               </el-form-item>
               <el-form-item>
                  <label slot="label" :style="$common.labelStyle('UDI')" v-html="$common.htmlLabel('UDI')"></label>
                  <el-input placeholder="" v-model="getRequestData.SEARCHVALUE" clearable></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <u-table size="mini" id="tableData" :row-height="30" :data="returnData.list" use-virtual :height="tableHeight" border style="width: 100%" stripe ref="stockTable" :header-cell-style="{ background: '#fff' }">
            <u-table-column show-overflow-tooltip prop="BATCH" label="生产批号/序列号" min-width="120px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="EXPIDATE" label="有效期/使用期限/失效日期" min-width="150px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="PCODE" label="物料编码" min-width="130px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="PNAME" label="商品名称" min-width="200px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="SPEC" label="规格/型号" min-width="120px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="STATE" label="状态" min-width="100px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="UDI" label="UDI" min-width="500px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="WCODE" label="入库单号" min-width="130px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="OCODE" label="出库单号" min-width="150px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="IDATE" label="入库时间" min-width="150px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="ODATE" label="ODATE" min-width="150px"></u-table-column>
            <u-table-column show-overflow-tooltip prop="MESS" label="MESS" min-width="120px"></u-table-column>
         </u-table>
      </div>
   </div>
</template>

<script>
import axios from 'axios'     // 引入axios
export default {
   name: "UDIrecord",
   data() {
      //这里存放数据
      return {
         WMS_URL: window.global_config.WMS_URL,
         tableHeight: 0,
         getRequestData: {
            SRQ: "", //开始时间
            ERQ: "",//结束时间
            GOID: 0,
            PNAME: "",//商品名称
            SEARCHVALUE: "",
            STAFFTOKEN: "CEF04463-B6FF-41F4-8978-8382C826BB59",
            TYPE: "UP",
            WHID: 0,
            GOCODE:"",
         },
         returnData: {
            total: 0, // 总条数
            list: [],
         },
         excelData: [],
         fieldList: [
            {
               label: "生产批号/序列号",
               prop: "BATCH",
               type: "string",
            },
            {
               label: "有效期/使用期限/失效日期",
               prop: "EXPIDATE",
               type: "string",
            },
            {
               label: "物料编码",
               prop: "PCODE",
               type: "string",
            },
            {
               label: "商品名称",
               prop: "PNAME",
               type: "string",
            },
            {
               label: "规格/型号",
               prop: "SPEC",
               type: "string",
            },
            {
               label: "状态",
               prop: "STATE",
               type: "string",
            },
            {
               label: "BOXCODE",
               prop: "BOXCODE",
               type: "string",
            },
            {
               label: "UDI",
               prop: "UDI",
               type: "string",
            },
            {
               label: "SN",
               prop: "SN",
               type: "string",
            },
            {
               label: "入库单号",
               prop: "WCODE",
               type: "string",
            },
            {
               label: "OCODE",
               prop: "OCODE",
               type: "string",
            },
            {
               label: "IDATE",
               prop: "IDATE",
               type: "string",
            },
            {
               label: "ODATE",
               prop: "ODATE",
               type: "string",
            },
            {
               label: "MESS",
               prop: "MESS",
               type: "string",
            }
         ],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //方法集合
   methods: {
      exportChange() {
         this.excelData = this.returnData.list; //将你要导出的数组数据（historyList）赋值给excelDate
         this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
      },
      //表格数据写入excel
      export2Excel() {
         var listBeiFen = JSON.parse(JSON.stringify(this.excelData))
         var nameList = []; //表格头 显示的所有字段
         var fieldList = []; //所有字段 显示的所有字段
         // 循环当前tab表格信息
         this.fieldList.forEach((item) => {
            nameList.push(item.label);
            fieldList.push(item.prop);

         });
         // 导出业务逻辑 引用封装好的js方法
         require.ensure([], () => {
            const {
               export_json_to_excel
            } = require("@/assets/excel/Export2Excel");
            //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
            const tHeader = nameList; // 导出的excel表头名信息
            const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
            const list = listBeiFen; // 查询的数据list
            // 进行数据json map 格式转换
            const data = this.formatJson(filterVal, list);
            // 调用方法传参      表头名信息 数据  导出的表格名称
            export_json_to_excel(tHeader, data, 'UDI记录');


         });
      },
      //格式转换方法
      formatJson(filterVal, jsonData) {
         return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      openSearch() { },
      // 数据搜索
      searchData() {
         this.getDataList()
      },
      getDataList() {
         var userInfo = this.$store.getters.getUserInfo
         var token = null
         if (userInfo != false) {
            token = sessionStorage.getItem('token')
         }
         axios({
            // 请求地址
            url: this.WMS_URL + '/DFTPLWMS/AUTOERPSERUDI',
            method: 'POST',
            headers: {
               token: token
            },
            data: this.getRequestData
         }).then(res => {
            if (res.data.status == 0) {
               this.returnData.list = res.data.rows
            }
            this.tableHeight = this.$common.getTableHeight()+40
         })
      },
   },

   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getRequestData.SRQ = this.$moment(new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD')
      this.getRequestData.ERQ = this.$moment(new Date()).format('YYYY-MM-DD')
      // this.getRequestData.GOCODE=String(JSON.parse(sessionStorage.getItem("loginInfo")).ormId)
      this.getDataList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { this.tableHeight = this.$common.getTableHeight()+40 },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight()+40 }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
   overflow-y: auto;
}

.dis {
   display: flex;
   flex-wrap: wrap !important;
}

#container {
   width: 980px;
   height: 700px;
}

::v-deep .amap-logo {
   display: none;
   opacity: 0 !important;
}

::v-deep .amap-copyright {
   opacity: 0;
}

::v-deep .info {
   position: relative;
   margin: 0;
   top: 0;
   right: 0;
   min-width: 0;
}
</style>
